import { render, staticRenderFns } from "./GlossaryPhraseForm.vue?vue&type=template&id=6aa69ad7&scoped=true&"
import script from "./GlossaryPhraseForm.vue?vue&type=script&lang=js&"
export * from "./GlossaryPhraseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aa69ad7",
  null
  
)

export default component.exports